<template>
  <div class="partner-detail">
    <div class="partner-detail-table">
      <vxe-toolbar size="mini" v-if="!disabled">
        <template v-slot:buttons>
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新建</el-button
          >
          <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="partnerDetailRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :edit-rules="chartRules"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in chartColumns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.editRender.name == 'select' && item.editRender.multiple == true">{{
              getMultipleLabel(item.editRender.dict, row[item.field])
            }}</span>
            <span v-else-if="item.editRender.name == 'select'">{{
              getLabel(item.editRender.dict, row[item.field])
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <search-table
              v-if="
                item.editRender?.name == 'downPartnerName' ||
                item.editRender?.name == 'upPartnerName'
              "
              v-model="row[item.field]"
              searchType="partnerNoFilter"
              :isMultiple="true"
              :extraData="partnerExtraData"
              :currentValue="row[item.field]"
              @input="(val) => chooseTable(val, row, item.field)"
            ></search-table>
            <el-select
              v-else-if="item.editRender.name == 'select'"
              clearable
              v-model="row[item.field]"
              :multiple="item.editRender.multiple"
              @change="handleChange(row, item.field)"
            >
              <el-option
                v-for="(i, index) in getDictList(item.editRender.dict)"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select>
            <el-input v-else v-model="row[item.field]" @input="() => handleChange(row, item.field)">
            </el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { upPartnerColumns, downPartnerColumns } from './index.js';
  import { upPartnerRules, downPartnerRules } from './rules.js';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  export default {
    name: 'PartnerDetailChart',
    mixins: [IntermodalityCommonMixin],
    components: {},
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      partnerType: {
        type: String,
        default: () => '上游',
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectedList: [],
        tableData: [],
      };
    },
    methods: {
      activeRowMethod() {
        //是否可以编辑
        return !this.disabled;
      },
      clearSelection() {
        this.$refs.partnerDetailRef.clearCheckboxRow();
        this.selectedList = [];
      },

      // //新插入一行或者编辑
      // async confirmHandler(data, isEdit) {
      //   if (isEdit) {
      //     const list = this.$refs.partnerDetailRef?.getTableData()?.fullData;
      //     const index = list.findIndex((item) => item._XID == data.xid);
      //     delete data.xid;
      //     console.log('edit', index, list);
      //     list.splice(index, 1, data);
      //     this.tableData = list;
      //   } else {
      //     await this.insertEvent(data, 0);
      //     this.tableData = this.getTableData();
      //   }

      //   this.$emit('handleChartChange', 'partner', this.tableData);
      // },
      // 新增行
      async newRowHandler() {
        this.clearSelection();
        this.insertEvent();
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.partnerDetailRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          // await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteRowHandler() {
        if (!this.selectedList.length || this.selectedList.length != 1) {
          this.$message.error('请勾选一条数据进行删除');
          return;
        }
        if (this.selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.partnerDetailRef.removeSelecteds();
            this.tableData = this.getTableData();
            this.$emit(
              'handleChartChange',
              this.partnerType == '上游' ? 'upPartners' : 'downPartners',
              this.tableData
            );
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectedList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        this.$refs.partnerDetailRef.clearValidate();
      },
      chooseTable(val, row, field) {
        console.log(val, row, field, '监听');
        if (field == 'upPartnerName') {
          const rowData = val[0];
          console.log('rowData', rowData);
          row.upPartnerCode = rowData.partnerCode;
          row.upPartnerName = rowData.partnerZhName;
          this._assignAdditionalInfo(rowData.partnerCode, row);
        } else if (field == 'downPartnerName') {
          const rowData = val[0];
          console.log('rowData', rowData);
          row.downPartnerCode = rowData.partnerCode;
          row.downPartnerName = rowData.partnerZhName;
          this._assignAdditionalInfo(rowData.partnerCode, row);
        }
      },
      async _assignAdditionalInfo(partnerCode, row) {
        let additionalInfo = await this.getPartnerInfo(partnerCode);
        if (!additionalInfo) {
          return;
        }
        let partnersPersons = additionalInfo.partnersPersons;
        if (this.partnerType == '上游') {
          row.upPartnerNature = additionalInfo.enterpriseType;
          row.upPartnerLegalPerson = additionalInfo.legalPerson;
          row.upPartherType = this.getLabel('partner_type', additionalInfo.partnerType);

          if (partnersPersons && partnersPersons.length) {
            row.upPartnerContactPerson = partnersPersons[0].contactPersonName;
            row.upPartnerContactPhone = partnersPersons[0].mobilePhone;
            row.upPartnerContactEmail = partnersPersons[0].email;
          }
        } else {
          row.downPartnerNature = additionalInfo.enterpriseType;
          row.downPartnerLegalPerson = additionalInfo.legalPerson;
          row.dowmPartherType = this.getLabel('partner_type', additionalInfo.partnerType);
          if (partnersPersons && partnersPersons.length) {
            row.downPartnerContactPerson = partnersPersons[0].contactPersonName;
            row.downPartnerContactPhone = partnersPersons[0].mobilePhone;
            row.downPartnerContactEmail = partnersPersons[0].email;
          }
        }
        this.$refs.partnerDetailRef.clearValidate();
      },
      async closeEditTableHandler() {
        const errMap = await this.$refs.partnerDetailRef.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          let tableData = this.getTableData();
          await this.$refs.partnerDetailRef.clearActived();
          this.tableData = tableData;
          this.$emit(
            'handleChartChange',
            this.partnerType == '上游' ? 'upPartners' : 'downPartners',
            tableData
          );
        }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.partnerDetailRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          val = val.map((item) => {
            if (this.partnerType == '上游') {
              if (
                item.upPartnerPayMethod?.length != 0 &&
                typeof item.upPartnerPayMethod == 'string'
              ) {
                if (item.upPartnerPayMethod.includes(',')) {
                  item.upPartnerPayMethod = item.upPartnerPayMethod.split(',');
                } else {
                  item.upPartnerPayMethod = [item.upPartnerPayMethod];
                }
              }
            } else {
              if (
                item.downPartnerPayMethod?.length != 0 &&
                typeof item.downPartnerPayMethod == 'string'
              ) {
                if (item.downPartnerPayMethod.includes(',')) {
                  item.downPartnerPayMethod = item.downPartnerPayMethod.split(',');
                } else {
                  item.downPartnerPayMethod = [item.downPartnerPayMethod];
                }
              }
            }
            return item;
          });
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve, reject) => {
          const $table = this.$refs.partnerDetailRef;
          let tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            console.log(tableData, '表格数据', valid);
            if (valid) {
              resolve({ tableData: tableData });
            } else {
              this.$message.error('请检查合作伙伴表格数据');
              reject({ tableData: [] });
            }
          });
        });
      },
    },
    computed: {
      chartColumns() {
        if (this.partnerType == '上游') {
          return upPartnerColumns;
        }
        return downPartnerColumns;
      },
      chartRules() {
        if (this.partnerType == '上游') {
          return upPartnerRules;
        }
        return downPartnerRules;
      },
      partnerExtraData() {
        return {
          //     // partnerTypes: 'HZHB01',
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
        };
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .partner-detail {
    background: #fff;

    .partner-detail-table {
      padding: 10px;
      box-sizing: border-box;
    }
  }
</style>
